import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Fires a Google Analytics 4 `page_view` event on every client-side route
 * change in the React SPA. The initial GA bootstrap (loading gtag.js + the
 * `config` call) happens in `public/index.html`. This component handles the
 * per-route page views that wouldn't otherwise reach GA because React Router
 * never triggers a full page reload.
 */
export default function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    const gaId = process.env.REACT_APP_GA_ID;
    if (!gaId || typeof window.gtag !== "function") return;

    const pagePath = location.pathname + location.search;
    const pageLocation = window.location.origin + pagePath;
    const pageTitle = document.title;

    window.gtag("event", "page_view", {
      page_path: pagePath,
      page_location: pageLocation,
      page_title: pageTitle,
      send_to: gaId,
    });
  }, [location.pathname, location.search]);

  return null;
}
